import React from "react";

import {
  FIELD_TYPE,
  FORMAT_TIME,
  tabKeys,
  TT_PHIEU_KHO,
  TT_PHIEU_VTYT,
} from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import { ColumnProps } from "../../../../../types/models";

const {
  INPUT,
  DATE_DISABLE_NO_DAY,
  DATE,
  COMBO_BOX,
  AUTO_COMPLETE,
  CODE,
  NUMBER,
  DATE_DISABLE,
} = FIELD_TYPE;

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 20,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mã đợt TD",
    key: "maDotTuyenDung",
    show: true,
    dataIndex: "maDotTuyenDung",

    align: "left",
    isResizable: true,
  },
  {
    title: "Tên đợt TD",
    key: "tenDotTuyenDung",
    show: true,
    dataIndex: "tenDotTuyenDung",

    align: "left",
    isResizable: true,
  },
  {
    title: "Từ ngày",
    key: "tuyenDungTuNgayDto",
    show: true,
    dataIndex: "tuyenDungTuNgayDto",

    align: "center",
    isResizable: true,
  },
  {
    title: "Đến ngày",
    key: "tuyenDungDenNgayDto",
    show: true,
    dataIndex: "tuyenDungDenNgayDto",

    align: "center",
    isResizable: true,
  },
  {
    title: "Số lượng tuyển dụng",
    key: "soLuong",
    show: true,
    dataIndex: "soLuong",
    width:160,
    align: "right",
    isResizable: true,
  },
  {
    title: "Mô tả",
    key: "moTa",
    show: true,
    dataIndex: "moTa",
    width:260,
    align: "left",
    isResizable: true,
  },
  {
    title: "Trạng thái",
    key: "idTrangThai",
    show: true,
    dataIndex: "idTrangThai",
    isResizable: true,
    align: "left",
    render: (text) => {
      if (text == 0) {
        return "Đã gia hạn";
      } else if (text == 1) {
        return "Đã xong";
      } else if (text == 2) {
        return "Đã đăng";
      } else if (text == 3) {
        return "Lên kế hoạch";
      }
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 160,
    key: "action",
  },
];
const listTT = [
  { value: 0, label: "Đã gia hạn" },
  { value: 1, label: "Đã xong" },
  { value: 2, label: "Đã đăng" },
  { value: 3, label: "Lên kế hoạch" },
];
const itemsInputField: DataFormField[] = [
  {
    type: INPUT,
    name: "maDotTuyenDung",
    label: "Mã đợt TD",
  },
  {
    type: INPUT,
    name: "tenDotTuyenDung",

    label: "Tên đợt TD",
  },
  {
    type: COMBO_BOX,
    name: "idTrangThai",

    label: "Trạng thái",
    options: listTT,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "tuyenDungTuNgay",
    label: "Từ ngày",
    disableDate: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "tuyenDungDenNgay",
    label: "Đến ngày",
    disableDate: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
];

export { allColumns, itemsInputField };
